import { getOrigin, convertLabelToTopic, buildPaginationRequestUrl } from '../utils';
import { GET, POST, PUT, DELETE } from './questions-connect-micros';

const MICROS_URL = getOrigin();
const TOPIC_URL = `${MICROS_URL}/rest/questions-connect/1.0/topic`;

export const createFormData = (topic, logoFile) => {
	const formData = new FormData();
	if (logoFile) {
		formData.append('logo', logoFile, 'topic-image.png');
	}
	formData.append('topic', new Blob([topic], { type: 'application/json' }));
	return formData;
};

export const postTopic = (name, description, featured, logoFile) => {
	const topic = JSON.stringify({ name, description, featured });
	const formData = createFormData(topic, logoFile);
	return POST(TOPIC_URL, formData).then((result) => result.json());
};

export const putTopic = (id, name, description, featured, logoFile, confluenceCloud) => {
	const topic = JSON.stringify({ id, name, description, featured, confluenceCloud });
	const formData = createFormData(topic, logoFile);
	return PUT(`${TOPIC_URL}/${id}`, formData);
};

export const getTopics = (pageNumber, featured, next) => {
	// undefined uses the default value specified in the function signature
	const url = buildPaginationRequestUrl(
		`${TOPIC_URL}?featured=${featured === false ? '' : featured}`,
		pageNumber,
		undefined,
		undefined,
		next,
	);
	return GET(url).then((result) => result.json());
};

export const getTopicsByName = (pageNumber, name) => {
	const url = buildPaginationRequestUrl(
		`${TOPIC_URL}/search?query=${name ? name : ' '}`,
		pageNumber,
	);
	return GET(url).then((result) => result.json());
};

export const getSingleTopicByName = (name) => {
	return GET(`${TOPIC_URL}/name/${encodeURIComponent(name)}`).then((result) => result.json());
};

export const getTopic = (id) => GET(`${TOPIC_URL}/${id}`).then((result) => result.json());

export const deleteTopic = (id, confluenceCloud) =>
	DELETE(`${TOPIC_URL}/${id}?confluenceCloud=${confluenceCloud ? 'true' : 'false'}`);

export const createIfRequired = (topics) =>
	PUT(`${TOPIC_URL}`, JSON.stringify(topics), { 'Content-Type': 'application/json' });

export const createTopicsFromLabels = (labelNames) =>
	createIfRequired(convertLabelToTopic(labelNames));
